"use strict";

exports.__esModule = true;
exports.data = exports.chains = void 0;
var _getChainIcon = require("../utils/get-chain-icon");
const data = {
  acala: {
    id: 'acala',
    display: 'Acala',
    icon: (0, _getChainIcon.getChainIcon)('acala'),
    paraChainId: 2000,
    isParaChain: false
  },
  karura: {
    id: 'karura',
    display: 'Karura',
    icon: (0, _getChainIcon.getChainIcon)('karura'),
    paraChainId: 2000,
    isParaChain: false
  },
  kusama: {
    id: 'kusama',
    display: 'Kusama',
    icon: (0, _getChainIcon.getChainIcon)('kusama'),
    paraChainId: -1,
    isParaChain: true
  },
  polkadot: {
    id: 'polkadot',
    display: 'Polkadot',
    icon: (0, _getChainIcon.getChainIcon)('polkadot'),
    paraChainId: -1,
    isParaChain: true
  },
  statemine: {
    id: 'statemine',
    display: 'Statemine',
    icon: (0, _getChainIcon.getChainIcon)('statemine'),
    paraChainId: 2001,
    isParaChain: false
  },
  quartz: {
    id: 'quartz',
    display: 'Quartz',
    icon: (0, _getChainIcon.getChainIcon)('quartz'),
    paraChainId: 2095,
    isParaChain: false
  },
  bifrost: {
    id: 'bifrost',
    display: 'Bifrost',
    icon: (0, _getChainIcon.getChainIcon)('bifrost'),
    paraChainId: 2001,
    isParaChain: false
  },
  laminar: {
    id: 'laminar',
    display: 'Laminar',
    icon: (0, _getChainIcon.getChainIcon)('laminar'),
    paraChainId: 777,
    isParaChain: false
  },
  hydra: {
    id: 'hydra',
    display: 'Hydra',
    icon: (0, _getChainIcon.getChainIcon)('hydra'),
    paraChainId: 82406,
    isParaChain: false
  },
  phala: {
    id: 'phala',
    display: 'Phala',
    icon: (0, _getChainIcon.getChainIcon)('phala'),
    paraChainId: 1,
    isParaChain: false
  },
  plasm: {
    id: 'plasm',
    display: 'Plasm',
    icon: (0, _getChainIcon.getChainIcon)('plasm'),
    paraChainId: 5000,
    isParaChain: false
  },
  polkabtc: {
    id: 'polkabtc',
    display: 'PolkaBTC',
    icon: (0, _getChainIcon.getChainIcon)('polkabtc'),
    paraChainId: 21,
    isParaChain: false
  },
  khala: {
    id: 'khala',
    display: 'Khala',
    icon: (0, _getChainIcon.getChainIcon)('khala'),
    paraChainId: 2004,
    isParaChain: false
  },
  kintsugi: {
    id: 'kintsugi',
    display: 'Kintsugi',
    icon: (0, _getChainIcon.getChainIcon)('kintsugi'),
    paraChainId: 2092,
    isParaChain: false
  }
};
exports.data = data;
const chains = data;
exports.chains = chains;